module.exports = "<div class=\"app\" id=\"top\">\n  <div *ngIf=\"loadedUser\">\n    <app-navbar></app-navbar>\n    <div class=\"view-area\" appScrollSpyElement=\"scroll\">\n      <router-outlet></router-outlet>\n    </div>\n    <app-footer></app-footer>\n    <app-toasts-container></app-toasts-container>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main